import {Form} from "antd"
import ProfileForm from "./ProfileForm"
import { profileAsync, selectAccount } from "../../../../app/store/reducers/auth/authReducer"
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from "react";




const EditProfileForm = () => {
    const [form] = Form.useForm()
    const account = useSelector(selectAccount)
    const dispatch = useDispatch()
    const initialValues = {
      // name: account?.name || "", 
      // surname: account?.surname || "", 
      // phoneNumber: account?.phone || "", 
      // country: account?.country || "", 
      // description: account?.description || ""
    }

    useEffect(() => {
      if (account) {
        form.setFieldValue("name", account?.name)
        form.setFieldValue("surname", account?.surname)
        form.setFieldValue("phoneNumber", account?.phone)
        form.setFieldValue("country", account?.country)
        form.setFieldValue("description", account?.description)
      }
    },[account])


    const onSubmit = (values) => {
        console.log("values", values)
        profileAsync({
          name: values?.name || "", 
          surname: values?.surname || "", 
          phone: values?.phoneNumber || "", 
          country: values?.country || "", 
          description: values?.description || ""
        })
    }

    // const test = {
    //     labelCol: {
    //       span: 64,
    //     },
    //     wrapperCol: {
    //       span: 64,
    //     },
    //   }
  return (
    <>
        <Form
            form={form}
            initialValues={initialValues}
            // name="control-hooks"
            layout="vertical"
            onFinish={onSubmit}
            // {...test}
        >
                <ProfileForm/>
        </Form>
    </>
  )
}

export default EditProfileForm